import Vue from 'vue'
import Router from 'vue-router'

//Main navigation view
import Main from "@/components/Navigation";

//Login
import Login from "@/components/Login";

//Appointments
import AppointmentsMain from "@/components/Appointments/Main";
import UserAppointments from "@/components/Appointments/List/User";
import AdminAppointments from "@/components/Appointments/List/Admin";

//Users
import Users from "@/components/Users/Index";
import Profile from "@/components/Users/Profile";

//Instruments
import Instruments from "@/components/Instruments/Index";

//Appointment types
import AppointmentTypes from "@/components/AppointmentType/Index";

//Appointment types
import Studio from "@/components/Studio/Index";

//Failure
import FailureList from "@/components/Failure/List";
import FailureReport from "@/components/Failure/CreateOrUpdate";

//Payment
import PaymentsList from "@/components/Payment/List";



Vue.use(Router)

export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login,
      meta: {
        roleAccessList: 'all'
      }
    },
    {
      path: "/Home",
      name: "Main",
      component: Main,
      children: [
        {
          path: "Appointments",
          name: "Appointments",
          component: AppointmentsMain,
          meta: {
            roleAccessList: 'all'
          }
        },
        {
          path: "Users",
          name: "Users",
          component: Users,
          meta: {
            roleAccessList: ['Administrator', 'Profesor', 'Supervizor']
          }
        },
        {
          path: "Instruments",
          name: "Instruments",
          component: Instruments,
          meta: {
            roleAccessList: ['Administrator']
          }
        },
        {
          path: "AppointmentTypes",
          name: "AppointmentTypes",
          component: AppointmentTypes,
          meta: {
            roleAccessList: ['Administrator']
          }
        },
        {
          path: "Studio",
          name: "Studio",
          component: Studio,
          meta: {
            roleAccessList: ['Administrator']
          }
        },
        {
          path: "MyAppointments",
          name: "MyAppointments",
          component: UserAppointments,
          meta: {
            roleAccessList: ['Polaznik', 'Profesor']
          }
        },
        {
          path: "AllAppointments",
          name: "AllAppointments",
          component: AdminAppointments,
          meta: {
            roleAccessList: ['Administrator']
          }
        },
        {
          path: "FailureReport",
          name: "FailureReport",
          component: FailureReport,
          meta: {
            roleAccessList: 'all'
          }
        },
        {
          path: "FailureList",
          name: "FailureList",
          component: FailureList,
          meta: {
            roleAccessList: ['Administrator', 'Tehničar']
          }
        },
        {
          path: "PaymentsList",
          name: "PaymentsList",
          component: PaymentsList,
          meta: {
            roleAccessList: ['Administrator']
          }
        },
        {
          path: "Profile",
          name: "Profile",
          component: Profile,
          meta: {
            roleAccessList: 'all'
          }
        },
        {
          path: "TargetProfile/:targetId",
          name: "TargetProfile",
          component: Profile,
          meta: {
            roleAccessList: ['Profesor', 'Administrator', 'Supervizor']
          }
        }
      ]
    }
  ],
})
router.beforeEach((to, from, next) => {
  // Postavljeno radi progressive web aplikacije 
  if(to.fullPath === '/index.html'){
    next('/')
  }
  else if (checkAccess(to.meta.roleAccessList)) {
    next();
  } else {
    next('/Home/Appointments')
  }
})

function checkAccess(roleAccessList) {
  var hasAccess = false;
  if (roleAccessList === 'all') {
    return true;
  }
  var roles = localStorage.getItem("user-roles").split(",");
  if(roles){
    roles.forEach(role => {
      if (roleAccessList.includes(role)) {
        hasAccess = true;
        return;
      }
    });
  }
  return hasAccess;
}